(function (global) {
    if (global.rlModule) {
        console.log("rlModule is defined!");
        return;
    }
    global.rlModule = (function () {
        var _module = {};
        _module.grid = function () {
            if ($(".rl-grid").length != 0) {
                grid();
            }

            function grid() {
                try {
                    $(".rl-grid").each(function (index, obj) {
                        if ($(obj).find(".flex-item").length == 0) {
                            var isReverse = $(obj).data("flex-reverse") == "1";
                            var layout = $(obj).data("flex-layout").split(",");
                            var space = $(obj).data("flex-space-px");
                            var spaceFlex = $(obj).data("flex-space");
                            var initWindowWidth = window.innerWidth;
                            var IsResize = false;

                            // 將div逆排列
                            if (isReverse) {
                                $(obj).css("flex-direction", "row-reverse");
                            }

                            // 分配寬度
                            for (var i = 0; i < layout.length; i++) {
                                var child = $(obj).children()[i];
                                if (child) {
                                    if ($(child).data("flex-order") != null) {
                                        $(child).css("flex", layout[i])
                                            .css("order", $(child).data("flex-order"))
                                            .addClass("flex-item");
                                    } else {
                                        $(child).css("flex", layout[i])
                                            .css("order", i)
                                            .addClass("flex-item");
                                    }
                                }
                            }

                            // 找出所有 flex-item
                            var item = $(obj).find(".flex-item").length;

                            // 產生間距
                            if ($(obj).find(".rl-flex-space").length == 0) {
                                addSpace(obj);
                            }

                            // 如果開啟時畫面小於991px,將flex-item分行
                            if (item >= 4) {
                                //沒有full-width的時候且 開啟畫面時小於991px
                                if ($(obj).hasClass('full-width') != true && IsResize == false && initWindowWidth < 991) {
                                    wrapFlexItem(obj);
                                    IsResize = true;
                                } else if (IsResize == false && initWindowWidth < 991 && initWindowWidth > 767) {
                                    wrapFlexItem(obj);
                                    IsResize = true;
                                }
                            }

                            // 當 window 縮放時
                            $(window).resize(function () {
                                var windowSize = window.innerWidth;
                                if (item >= 4) {
                                    //當數量是4個以上的時候

                                    if ($(obj).hasClass('full-width') && windowSize <= 767 && IsResize == true) {
                                        //  當window在767以下,且分行過
                                        $(obj)
                                            .find(".wrap1")
                                            .children()
                                            .unwrap();
                                        $(obj)
                                            .find(".wrap2")
                                            .children()
                                            .unwrap();
                                        $(obj)
                                            .find(".wrap2")
                                            .removeClass("rl-row-top-20");

                                        $(obj)
                                            .find(".rl-flex-space")
                                            .remove();

                                        if ($(obj).find(".rl-flex-space").length == 0) {
                                            addSpace(obj);
                                        }
                                        IsResize = false;
                                    } else if (windowSize > 767 && windowSize <= 991) {
                                        //當window在767以上,991以下
                                        if (IsResize == false) {
                                            //沒有分行過
                                            if ($(obj).find(".rl-flex-space").length == 0) {
                                                addSpace(obj);
                                            }
                                            $(obj).find(".wrap2").addClass("rl-row-top-20"); wrapFlexItem(obj);
                                            IsResize = true;
                                        }
                                    } else if (windowSize > 991) {
                                        // 當window在991以上
                                        if (IsResize == true) {
                                            $(obj).find(".wrap1").children().unwrap();
                                            $(obj).find(".wrap2").children().unwrap();
                                            $(obj).find(".rl-flex-space").remove();

                                            if ($(obj).find(".rl-flex-space").length == 0) {
                                                addSpace(obj);
                                            }
                                            IsResize = false;
                                        }
                                    }
                                } else {
                                    //當數量不足4個的時候
                                    if (windowSize > 767 && IsResize == true) {
                                        if ($(obj).find(".rl-flex-space").length == 0) {
                                            addSpace(obj);
                                        }
                                        IsResize = false;
                                    } else if (windowSize < 576 && IsResize == false) {
                                        IsResize = true;
                                    }
                                }
                            });

                            function wrapFlexItem(obj) {

                                $(obj).children().filter(function (index, items) {
                                    if ($(obj).find(".rl-flex-space").length == 0) {
                                        if (index < item / 2) {
                                            return items;
                                        }
                                    } else {
                                        if (index < (2 * item - 1) / 2) {
                                            return items;
                                        }
                                    }
                                })
                                    .wrapAll(
                                    "<div style='width:100%' class='wrap1 rl-flex-wrap'></div>"
                                    );

                                $(obj).find(".wrap1").children().each(function (index, items) {
                                    var length = $(obj)
                                        .find(".wrap1")
                                        .children().length;
                                    if (
                                        length - 1 == index &&
                                        $(items).hasClass("rl-flex-space") == true
                                    ) {
                                        $(items).remove();
                                    }
                                });

                                $(obj).children().filter(function (index, items) {
                                    if ($(items).hasClass("wrap1") == false) {
                                        return items;
                                    }
                                })
                                    .wrapAll(
                                    "<div style='width:100%' class='wrap2 rl-justify-content-center rl-row-top-20 rl-flex-wrap'></div>"
                                    );
                                $(obj).find(".wrap2").children().each(function (index, items) {
                                    if (
                                        index == 0 &&
                                        $(items).hasClass("rl-flex-space") == true
                                    ) {
                                        $(items).remove();
                                    }
                                });
                            }

                            function addSpace(obj) {
                                if (spaceFlex != null) {
                                    $(obj).find(".flex-item").each(function (index, items) {
                                        if (item - 1 != index) {
                                            if ($(items).data("flex-order") != null) {
                                                $(items).after(
                                                    "<div class='rl-flex-space' style='order:" +
                                                    $(items).data("flex-order") +
                                                    " ; flex:" +
                                                    spaceFlex +
                                                    " 1 0%;'></div>"
                                                );
                                            } else {
                                                $(items).after(
                                                    "<div class='rl-flex-space' style='order:" +
                                                    index +
                                                    " ; flex:" +
                                                    spaceFlex +
                                                    " 1 0%;'></div>"
                                                );
                                            }
                                        }
                                    });
                                } else if (space != null) {
                                    $(obj).find(".flex-item").each(function (index, items) {
                                        if (item - 1 != index) {
                                            if ($(items).data("flex-order") != null) {
                                                $(items).after(
                                                    "<div class='rl-flex-space' style='order:" +
                                                    $(items).data("flex-order") +
                                                    " ; width:" +
                                                    space +
                                                    "px;'></div>"
                                                );
                                            } else {
                                                $(items).after(
                                                    "<div class='rl-flex-space' style='order:" +
                                                    index +
                                                    " ; width:" +
                                                    space +
                                                    "px;'></div>"
                                                );
                                            }
                                        }
                                    });
                                } else {
                                    $(obj).find(".flex-item").each(function (index, items) {
                                        if (item - 1 != index) {
                                            if ($(items).data("flex-order") != null) {
                                                $(items).after(
                                                    "<div class='rl-flex-space' style='order:" +
                                                    $(items).data("flex-order") +
                                                    "'></div>"
                                                );
                                            } else {
                                                $(items).after(
                                                    "<div class='rl-flex-space' style='order:" +
                                                    index +
                                                    "'></div>"
                                                );
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    });
                } catch (e) {
                    console.log(e);
                }
            }
        };

        _module.ready = $(document).ready(function () {
            popupVideo(".rl-popup-video");
            popupImg(".rl-popup-img");

            _module.grid();

            function popupVideo(videoId) {
                $(videoId).magnificPopup({
                    type: "iframe",
                    tLoading: "Loading image #%curr%...",
                    mainClass: "mfp-img-mobile"
                });
            }
            function popupImg(target) {
                $(target).magnificPopup({
                    type: 'image',
                    closeOnContentClick: true,
                    mainClass: 'mfp-img-mobile',
                    image: {
                        verticalFit: true
                    }
                });
            }

            $(".rl-slide").slick({
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: true,
                dots: true,
                infinite: true
            });
        });

        return _module;
    })();
})(window);
